import {
  Folder,
  ModelUtils,
  rootFolder,
  TemplatingItemDetail,
  TemplatingItem,
} from '../models';
import { useCallback } from 'react';
import { apiHooks } from '../../../hooks/useRestAPIHooks';
import { useInvalidateTemplatingItems } from './useInvalidateTemplatingItems';
import { KnownImpressionTypes } from '../../SubjectViewer/Modules/AITools/ImpressionEditor/ImpressionItem';

export const useCreateTemplatingItem = ({
  onSuccess,
}: {
  onSuccess?: (templatingItem: TemplatingItemDetail) => void;
} = {}) => {
  const invalidateTemplatingItems = useInvalidateTemplatingItems();
  const createTemplatingItemMutation = apiHooks.useAPIMutation(
    'POST /v1/ai-templates',
    {},
  );

  const createTemplatingItem = useCallback(
    async ({
      type,
      name,
      folderName,
      parentFolder = rootFolder,
      impressionType,
    }: {
      type: TemplatingItem['type'];
      name: string;
      folderName?: string;
      parentFolder?: Folder;
      impressionType?: KnownImpressionTypes;
    }) => {
      const folder = folderName
        ? ModelUtils.moveToFolder(
            ModelUtils.createFolder(folderName),
            parentFolder,
          )
        : parentFolder;

      const newTemplatingItem = ModelUtils.createNewTemplatingItem({
        type,
        name,
        folder,
        impressionType,
      });

      await createTemplatingItemMutation.mutateAsync(newTemplatingItem, {
        onSuccess: ({ template: templatingItemRaw }) => {
          invalidateTemplatingItems(parentFolder, folder);
          const templatingItem =
            ModelUtils.templatingItemDetailFromRawData(templatingItemRaw);
          onSuccess?.(templatingItem);
        },
      });
    },
    [createTemplatingItemMutation, invalidateTemplatingItems, onSuccess],
  );

  return {
    createTemplatingItem,
    error: createTemplatingItemMutation.error,
    reset: createTemplatingItemMutation.reset,
  };
};
